<script setup lang="ts">
import { isNotEmpty } from '@/utils/util'
import { computed } from 'vue'

// true 是 light，false 是dark
const props = defineProps({
  theme: {
    type: Boolean,
    default: true
  },
  text: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    required: false,
    default: ''
  },
  weakText: {
    type: String,
    required: false,
    default: ''
  },
  verticle: {
    type: Boolean,
    default: false
  },
  tip: {
    type: String,
    required: false,
    default: ''
  },
  flatRight: {
    type: Boolean,
    default: false,
    required: false
  },
  tipIcon: {
    type: Boolean,
    default: false,
    required: false
  }
})

const theme = computed(() => {
  return props.theme
})
</script>
<template>
  <div
    relative
    py-1.8
    w-auto
    px-3
    cursor-pointer
    flex
    items-center
    justify-center
    :class="[
      theme
        ? 'text-theme-dark bg-white/40 hover:bg-white/30 border-white/20 hover:border-white/40'
        : 'text-theme-inverted bg-black/30 hover:bg-black/30 border-white/30 hover:border-white/30',
      props.verticle ? 'flex-col-reverse' : 'flex-row',
      props.flatRight ? 'rounded-r-0 pr-1 pl-3.5 py-1 border-r-0' : ''
    ]"
    backdrop-blur-md
    backdrop-saturate-200
    rounded-full
    border-1
    transition-all
    duration-300
    hover:backdrop-blur-lg
    hover:shadow-sm>
    <div v-if="props.tip" absolute top--2.8 right--2 bg-danger-active rounded-full px-2 text-xs text-inverted py-0.4>
      {{ props.tip }}
    </div>
    <div v-if="props.tipIcon" absolute top--1.5 right-0 bg-danger-active rounded-full h-3 w-3 />
    <div
      v-if="isNotEmpty(props.icon)"
      :class="[isNotEmpty(props.text) ? (props.verticle ? 'mt--1 !text-base' : 'mr-1') : '', props.icon]"
      text-xl></div>
    <div flex-r-center>
      <div flex-l-center justify-center>
        <span v-if="isNotEmpty(props.text)" :class="isNotEmpty(props.weakText) ? 'text-sm' : 'text-sm'">{{
          props.text
        }}</span>
        <span v-if="isNotEmpty(props.weakText)" text-2.6 mt--0.2 opacity-80>{{ props.weakText }}</span>
      </div>
    </div>
    <slot name="icon"></slot>
  </div>
</template>

<style scoped>
/* style */
</style>
